// extracted by mini-css-extract-plugin
export default {"hotelSelection":"Welcome_hotelSelection__Acaez","subtitle":"Welcome_subtitle__5PPAb","inner":"Welcome_inner__p03R6","hgroup":"Welcome_hgroup__jwSn-"};